const cities = [
  {
    name: "Rome",
    key: "Rome",
    music: "https://soundcloud.com/ahdab1122/sets/andrea-bocelli"
  },
  {
    name: "Morocco",
    key: "Morocco",
    music: "https://soundcloud.com/pixunivers/sets/morocco"
  },
  {
    name: "Paris",
    key: "Paris",
    music: "https://soundcloud.com/natalia-copaceanu/sets/edit-piaf"
  },
  {
    name: "Bali",
    key: "Bali",
    music: "https://soundcloud.com/desta-adnyana/gamelan-pesel-1"
  },
  {
    name: "Japan",
    key: "Japan",
    music: "https://soundcloud.com/adronius/sets/japanese-traditional"
  },
  {
    name: "New York",
    key: "NYC",
    music: "https://soundcloud.com/franklyn-willingham/sets/jay-z-new-york"
  },
  {
    name: "India",
    key: "India",
    music:
      "https://soundcloud.com/indiatribemusiccollection/sets/traditional-indian-music-for"
  },
  {
    name: "London",
    key: "London",
    music: "https://soundcloud.com/rlbpmd/sets/beatles"
  },
  {
    name: "Egypt",
    key: "Egypt",
    music: "https://soundcloud.com/norhan-nabil-ellicy/sets/egypt"
  },
  {
    name: "Berlin",
    key: "Berlin",
    music:
      "https://soundcloud.com/djdabura/opening-set-from-spybar-for-monolink-10-10-19"
  },
  {
    name: "Mexico",
    key: "Mexico",
    music:
      "https://soundcloud.com/user-92805118/sets/fiesta-del-norte-audio-clips"
  }
];

export default cities;
